import { jsx as _jsx } from "react/jsx-runtime";
import { Deadline as BaseDeadline } from "sprout-ui-dom";
import { CSSTransitionPortal } from "sprout-ui-dom/dist/Portal";
import OutsideClickListener from "sprout-ui-dom/dist/internal/OutsideClickListener";
import styled from "styled-components";
import { DialogRoot } from "./styles";
import useDialogOverlayHandlers from "./useDialogOverlayHandlers";
const dialogTimeout = {
    enter: 0,
    exit: 0
};
const Deadline = styled(BaseDeadline)`
  width: 100%;
  margin: 56px auto 24px;
  pointer-events: auto;
`;
const DeadlineDialog = (props)=>{
    const { onRequestClose , open , onSetDeadline , items  } = props;
    const { onExited , onEnter  } = useDialogOverlayHandlers();
    return /*#__PURE__*/ _jsx(CSSTransitionPortal, {
        open: open,
        timeout: dialogTimeout,
        onEnter: onEnter,
        onExited: onExited,
        children: /*#__PURE__*/ _jsx(OutsideClickListener, {
            onOutsideClick: onRequestClose,
            children: /*#__PURE__*/ _jsx(DialogRoot, {
                flexDirection: "column",
                children: /*#__PURE__*/ _jsx(Deadline, {
                    items: items,
                    onSetDeadline: onSetDeadline,
                    onEscape: onRequestClose
                })
            })
        })
    });
};
export default DeadlineDialog;
